import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Store } from '@ngxs/store';

import { ProfileResponse } from '@smarthead-api/models/profile-response';

import { ProfileState } from '@client/app/profile/state/profile.state';
import { TutorialsService } from '@client/app/shared/services/tutorials.service';

import { RouterLinkCreatorService } from '../../../../services/router-link-creator.service';
import { MainNavItemsService } from '../../services/main-nav-items.service';
import { MainNavService } from '../../services/main-nav.service';

@Component({
  selector: 'sh-main-nav-platform-desktop',
  templateUrl: './main-nav-platform-desktop.component.html',
  styleUrl: './main-nav-platform-desktop.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MainNavPlatformDesktopComponent {
  constructor(
    private routerLinkCreatorService: RouterLinkCreatorService,
    public mainNavService: MainNavService,
    public items: MainNavItemsService,
    private tutorialsService: TutorialsService,
    private store: Store
  ) {}

  loadedProfileSubscription$ = this.store.select(ProfileState.getProfileActiveSubscription);

  knowledgeBaseURL = this.tutorialsService.getKnowledgeBaseUrl();

  openProfile(profile: ProfileResponse) {
    return this.routerLinkCreatorService.navigateToProfile(profile.id, profile.title, 'ADMIN-DASHBOARD');
  }

  onBecameEsgProBtnClick(profileId: number, subscriptionType: string): void {
    this.tutorialsService.trackEventClickOnTutorials(profileId, subscriptionType);
  }
}
